/* eslint-disable */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import CompanyPicker from "../components/CompanyPicker";
import FullscreenLoading from "../components/FullscreenLoading";

import { AuthContext } from "./AuthProvider";
import { DomainContext } from "./DomainProvider";
export const CompanyContext = React.createContext({

    company: null,
    companies: null,
    getUsers: () => {},
    reloadCompanyUsers: () => {},
    changeCompany: () => {},
    hasPermission: () => {}
})

export const CompanyProvider = ({children}) => {

    const { company, apiCall, contextNotifications } = useContext(AuthContext)
    const { domainPermissions } = useContext(DomainContext)

    const params = useParams()

    const [companyUsers, setCompanyUsers] = useState([])
    const [companyPermissions, setCompanyPermissions] = useState(null)
    const [companyTags, setCompanyTags] = useState([])
    const [companyType, setCompanyType] = useState(null)
    const [companyNotifications, setCompanyNotifications] = useState([])
    const [companyTeams, setCompanyTeams] = useState([])
    const [companyShortcuts, setCompanyShortcuts] = useState([])

    const [unreadMessages, setUnreadMessages] = useState([])
    
    const [consultants, setConsultants] = useState([])

    const [companies, setCompanies] = useState(null)
    const [companyStore, setCompanyStore] = useState(JSON.parse(localStorage.getItem('tudu.companyStore')))

    const [noAccess, setNoAccess] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [isArchived, setIsArchived] = useState(false)

    useEffect(() => {
        
        if(company){
            
            loadCompanySettings()
        }   
        
    }, [])

    useEffect(() => {
        if(company){
            setCompanyNotifications(contextNotifications.filter(n => !n.isRead && n.company?.id === company.id))
        }
    }, [contextNotifications])

    useEffect(() => {
        
        if(company){
            loadCompanySettings()
            loadUnreadMessages()
        }
        
    }, [company])

    useEffect(() => {
        if(company){
            localStorage.setItem('tudu.companyStore', JSON.stringify(company))
        }
    }, [companyStore])

    const loadCompanySettings = async () => {
        
        if(params.company){
            const { data } = await apiCall({
                action: 'load-company-settings'
            })
            console.log('loadCompanySettings', data)
            if(data.status === 1){
                setNoAccess(false)
                setCompanyUsers(data.data.users)
                setCompanyPermissions(data.data.permissions)
                setConsultants(data.data.consultants)
                setCompanyTags(data.data.tags)
                setCompanyType(data.data.type)
                setCompanyTeams(data.data.teams)
                setCompanyShortcuts(company.properties?.shortcuts ? company.properties.shortcuts : [])
                setIsArchived(data.data.archived)
            }else{
                setErrorMessage(data.message)
                setNoAccess(true)
            }
        } 
    }

    const reloadCompanyProperties = async () => {
        const { data } = await apiCall({
            action: 'get-company-properties',
        })
        if(data.status === 1 && data.data && data.data.shortcuts){
            setCompanyShortcuts(data.data.shortcuts)
        }
    }

    const reloadCompanyUsers = async () => {
        //Fokuser på å laste inn nye brukere når det oppdateres
        const { data } = await apiCall({action: 'get-company-employees'})
        
        if(data.status === 1){
            setCompanyUsers(data.data)
        }

        return true
    }

    const loadUnreadMessages = async () => {
        const { data } = await apiCall({
            action: 'load-unread-company-messages'
        })

        setUnreadMessages(data.data)
    }

    const reloadAdmins = async () => {
        const { data } = await apiCall({
            action: 'reload-company-admins'
        })

        setConsultants(data.data)
    }

    const loadTeams = async () => {
        const { data } = await apiCall({
            action: 'get-company-teams',
        })

        if(data.status === 1){
            setCompanyTeams(data.data)
        }
    }

    const updateBrregInfo = async () => {
        const { data } = await apiCall({action: 'update-company-brreg'})
    }

    const render = () => {
        
        if(noAccess){
            return <NoAccess />
        }

        if(company) return children

        if(!companies){
            return <FullscreenLoading customText="Laster inn informasjon om området..."/>
        }

        if(companies.length === 1){
            setCompany(companies[0])
        }

        if(companies.length > 1) return <SelectCompany />

        if(!company) return <FullscreenLoading customText="Laster inn informasjon om området..."/>

        return children
    }

    const SelectCompany = () => {
        if(companyStore){
            loadCompanyById(companyStore.id)
        }
        return (
            <div className="d-flex flex-column vh-100 align-items-center pre-company-choice" style={{backgroundColor: 'rgba(0,0,0,.025)'}}>
                <div className="bg-white shadow-sm mt-5 rounded col-xl-4">
                    <div className="px-5 pt-4 mb-3 text-center">
                        
                    <img src={process.env.PUBLIC_URL + "/gfx/saga_kl_logo.png"} className="my-2 mx-3" height="40"/>
                    {/*
                    <svg style={{height: 70}} id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 425"><defs></defs><path class="cls-1" d="M367.41,166.49,241.58,384.42a14.25,14.25,0,0,1-19.46,5.22L40.59,284.8a14.23,14.23,0,0,1-5.22-19.46L161.2,47.42a14.26,14.26,0,0,1,19.46-5.22l24.05,13.93a13.94,13.94,0,0,0,5.12,19.09l109.15,63a14,14,0,0,0,19.15-5.11L362.19,147a14.21,14.21,0,0,1,5.22,19.45M293.08,24.34A20.62,20.62,0,1,1,314.83,55L291.39,41.43a20.64,20.64,0,0,1,1.69-17.09m96,105.86-36.91-21.3,5.53-9.67a16.86,16.86,0,0,0-6.19-23.09L329.88,63.65A35.93,35.93,0,0,0,340.94,52a34.63,34.63,0,1,0-64.61-19.2L247.36,16a16.91,16.91,0,0,0-23.09,6.19l-5.53,9.63-36.91-21.3a27.39,27.39,0,0,0-37.47,10L3.68,264.17a27.43,27.43,0,0,0,10,37.47L221,421.32a27.4,27.4,0,0,0,37.47-10.08L399.1,167.62a27.38,27.38,0,0,0-10-37.42" transform="translate(0 0)"/><path class="cls-1" d="M191.51,223.37l-17.1-17.1a10.2,10.2,0,0,0-14.49,0l-5.32,5.32a10.27,10.27,0,0,0,0,14.49l30,30a10.31,10.31,0,0,0,7.37,3,10.09,10.09,0,0,0,7.32-3.23l52.11-55.23a10.21,10.21,0,0,0-.4-14.44L245.57,181a10.37,10.37,0,0,0-14.54.41Z" transform="translate(0 0)"/><path class="cls-2" d="M202.77,288a74.49,74.49,0,1,1,74.33-74.48A74.49,74.49,0,0,1,202.77,288m0-177c-56.41,0-102.34,46-102.34,102.49a102.34,102.34,0,1,0,204.68,0c0-56.52-45.93-102.49-102.34-102.49" transform="translate(0 0)"/><path class="cls-2" d="M798.38,363A5,5,0,0,0,794,360.4a7.58,7.58,0,0,0-5.84,3q-9.95,11.9-15.89,17.19T762,385.91a5.44,5.44,0,0,1-4.54-2.27,10.3,10.3,0,0,1-1.73-6.38q0-6.48,6.05-34.16,5.4-24.21,5.41-29.62,0-3.24-1.95-4.43c-1.3-.79-3.6-1.19-6.92-1.19q-7.14,0-10.7,2.81t-5.3,9.3a263.76,263.76,0,0,1-10.7,32.43q-5.51,13.19-10.38,19.67t-8.1,6.49a3.74,3.74,0,0,1-3.47-1.84c-.72-1.23-1.08-3.35-1.08-6.38q0-7.56,4.33-30.27,1.29-6.48,3.46-14.48,2.37-9.94,2.37-11.68a5.56,5.56,0,0,0-1.83-4.54c-1.23-1-3.43-1.51-6.6-1.51q-8.43,0-12.32,2.81T691.9,320a186.12,186.12,0,0,0-7.14,28.64,177.63,177.63,0,0,0-2,21.14,118.71,118.71,0,0,1-10.75,11q-6.06,5.19-11.9,5.19-4.53,0-7.45-5.41t-3.79-17.94A420.9,420.9,0,0,0,680.65,296q11.9-32.43,11.9-56.65,0-17.07-6.17-25.51t-15.46-8.43q-18.81,0-30.37,29.73t-15.68,71.67A58.68,58.68,0,0,0,596,317.91a65.61,65.61,0,0,0-20.22,24.22,71,71,0,0,0-7.34,31c-2.86,3.12-5.36,5.64-7.47,7.52q-5.94,5.29-10.27,5.3a5.46,5.46,0,0,1-4.54-2.27,10.36,10.36,0,0,1-1.73-6.38q0-6.48,6.06-34.16,5.4-24.21,5.4-29.62c0-2.16-.64-3.64-1.94-4.43s-3.61-1.19-6.92-1.19q-7.14,0-10.7,2.81T531,320a263.76,263.76,0,0,1-10.7,32.43q-5.52,13.19-10.38,19.67t-8.11,6.49a3.72,3.72,0,0,1-3.46-1.84c-.72-1.23-1.08-3.35-1.08-6.38q0-7.56,4.32-30.27,1.31-6.48,3.46-14.48,2.39-9.94,2.38-11.68a5.54,5.54,0,0,0-1.84-4.54c-1.22-1-3.42-1.51-6.59-1.51q-8.43,0-12.32,2.81t-6.06,9.3a188.46,188.46,0,0,0-7.14,28.64,177.63,177.63,0,0,0-2,20.88,108.46,108.46,0,0,1-11.41,10.8,25.87,25.87,0,0,1-16.44,5.62q-11.46,0-16.75-9.08t-5.3-31.57q0-6,.43-16.86h26.38q24.44,0,24.43-14.92c0-2.73-.51-4.61-1.51-5.62s-2.67-1.51-5-1.51H442.18q28.11-24.87,28.11-58.38,0-12.1-5.19-20.11t-14.27-8q-12.33,0-23,11.68t-18.27,31.35a210.06,210.06,0,0,0-11.24,43.46H386q-9.72,0-9.73,12.1c0,3.46.76,6,2.27,7.57s4.44,2.38,8.76,2.38h8.43q-.65,9.74-.65,19.24,0,62.06,44.11,62.05a44.57,44.57,0,0,0,25.3-7.35,85.16,85.16,0,0,0,9.84-7.71,32.5,32.5,0,0,0,3.24,6.09q6.15,9,15.89,9,8.43,0,15.78-7.89t11-22.59q0,14.48,4.86,22.48t15.24,8a41.93,41.93,0,0,0,24.33-7.35,85.69,85.69,0,0,0,9-7.13,31.79,31.79,0,0,0,3.35,4.64,27.5,27.5,0,0,0,21.73,9.84,31.52,31.52,0,0,0,15.89-3.89q6.81-3.9,15.89-15.35,8.64,19.24,25.08,19.24,10.38,0,21-7.68a98.75,98.75,0,0,0,9-7.37,31.81,31.81,0,0,0,3.23,6.08q6.16,9,15.89,9,8.43,0,15.78-7.89t11-22.59q0,14.48,4.87,22.48t15.24,8a41.93,41.93,0,0,0,24.32-7.35,95.58,95.58,0,0,0,20-18.81q4.11-4.75,4.11-13.41A13.42,13.42,0,0,0,798.38,363ZM653.3,279.32q2.93-23.56,7-38.16t8.21-14.59q2,0,3.36,4.54a45.42,45.42,0,0,1,1.4,12.76q0,32-24.21,84.75Q650.38,302.88,653.3,279.32Zm-223.12-8.11q3.57-14.37,7.57-22.48t7.24-8.11q4.75,0,4.76,12.76,0,11.24-6.38,25a74,74,0,0,1-19.14,24.75A302.54,302.54,0,0,1,430.18,271.21ZM614.49,384.5a13,13,0,0,1-8.21,3.35q-10.81,0-10.81-15.78a48.93,48.93,0,0,1,7.89-27.13q7.89-12.21,19.78-15.89-.43,11.67-.43,16.86a144.4,144.4,0,0,0,2.16,26.16Q618.6,381.15,614.49,384.5Z" transform="translate(0 0)"/></svg>
                    */}
                        </div>   
                    <div className="w-100 mt-4 text-center box-heading">
                        <h4 className="fw-bold">Velg bedrift</h4>
                    </div>
                    <div>
                        <CompanyPicker /> 
                    </div>
                </div>
            </div>
        )
    }

    return <CompanyContext.Provider value={{
        company,
        companies,
        companyUsers,
        companyPermissions,
        companyTags,
        companyType,
        companyTeams,
        companyShortcuts,
        consultants,
        unreadMessages,
        companyNotifications,
        errorMessage,
        isArchived,
        loadTeams,
        reloadAdmins,
        reloadCompanyUsers,
        updateBrregInfo,
        reloadCompanyProperties,
        changeCompany: (id) => {
            
        },
        hasPermission: (permissions) => {
            if(domainPermissions){
                if(domainPermissions?.permissions.includes('superAdmin')) return true
                if(domainPermissions?.permissions?.some(r=> permissions.includes(r))) return true
            }
            return companyPermissions?.permissions?.some(r=> permissions.includes(r))
        },
        hasCompanyPermission: (permissions) => {
            
            if(companyPermissions && companyPermissions?.permissions.includes('allPermissions')){
                return true
            }
            return companyPermissions?.permissions?.some(r=> permissions.includes(r))
        },
    }}>
        {render()}
    </CompanyContext.Provider>
}

function Loading(){
    return (
        <div className="px-4">
            <div className="py-5 d-flex flex-column justify-content-center align-items-center">
                <div className="bg-success-tint mb-3" style={{width: 90, height: 90, borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <span className="fa-stack fa-lg">
                        
                        <FontAwesomeIcon fixedWidth size="lg" icon={['fad', 'building']} className="fa-stack-lg text-secondary" />
                        <FontAwesomeIcon fixedWidth spin size="3x" icon={['fad', 'spinner-third']} className="fa-stack-3x text-primary" />
                    </span>
                </div>
                <div className="text-center">
                    <h6 className="bold text-primary">Laster bedrift</h6>
                    <p>Vent litt mens vi henter all informasjon om den bedriften.</p>
                </div>
            </div>
        </div>
    )
}

function NoAccess(){

    const navigate = useNavigate()
    const { errorMessage } = useContext(CompanyContext)
    return (
        <div className="px-4">
            <div className="py-5 d-flex flex-column justify-content-center align-items-center">
                <div className="bg-danger mb-3" style={{width: 90, height: 90, borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <FontAwesomeIcon fixedWidth size="3x" icon={['fad', 'xmark']} className="text-white" />
                </div>
                <div className="text-center">
                    <h3 className="bold text-primary">Ingen tilgang</h3>
                    <p>{errorMessage ? errorMessage : 'Du har ikke tilgang til denne bedriften'}</p>
                    <button className="btn btn-primary" onClick={() => navigate('/')}>Tilbake</button>
                </div>
            </div>
        </div>
    )
}